// Toont de tv echt beeld? 's Avonds gaat alleen de tv uit en draait de Pi gewoon door.
// Zonder beeld levert de browser (bijna) geen frames meer: requestAnimationFrame telt ze, een
// setInterval kijkt hoeveel het er waren. Blijft dat darkAfterMs onder screenMinFps, dan is de tv uit.
// useSaleEvents gebruikt de gemeten donkertijd voor het inhalen (catchUpDarkMs).

import { screenCheckMs, screenMinFps } from "../constants";
import { darkAfterMs, deviceName } from "./device";

const listeners = new Set();

let watchers = 0;
let frames = 0;
let lastFrameAt = 0;
let lastCheckAt = 0;
let lowSince = 0;
let awake = true;
let darkAt = null;
let rafId = 0;
let timerId = 0;

function tick() {
  frames += 1;
  lastFrameAt = Date.now();
  rafId = requestAnimationFrame(tick);
}

function announce(event) {
  listeners.forEach((listener) => listener(event));
}

function clock(at) {
  return new Date(at).toTimeString().slice(0, 5);
}

function goDark(at) {
  awake = false;
  darkAt = at;
  console.info(`[dashboard] ${deviceName()}: beeld weg om ${clock(at)}`);
  announce({ awake: false, darkAt: at, sleptMs: 0 });
}

function goAwake(at) {
  const was = darkAt;
  const sleptMs = was ? at - was : 0;
  awake = true;
  darkAt = null;
  console.info(
    `[dashboard] ${deviceName()}: beeld terug om ${clock(at)}, ${Math.round(sleptMs / 60000)} min donker`,
  );
  announce({ awake: true, darkAt: was, sleptMs });
}

// Eén meetronde: hoeveel frames vielen er in dit venster?
function check() {
  const at = Date.now();
  const span = at - lastCheckAt;
  lastCheckAt = at;

  const fps = span > 0 ? (frames * 1000) / span : 0;
  frames = 0;

  // Een verborgen tabblad tekent zeker niet.
  const hidden =
    typeof document !== "undefined" && document.visibilityState === "hidden";
  const low = hidden || fps < screenMinFps;

  if (!low) {
    lowSince = 0;
    if (!awake) goAwake(at);
    return;
  }

  // Donker sinds het laatst geziene frame, niet sinds het moment dat we het merken.
  if (!lowSince) lowSince = lastFrameAt || at;
  if (awake && at - lowSince >= darkAfterMs()) goDark(lowSince);
}

// Zonder meting (server, test) staat het scherm aan.
export function isScreenAwake() {
  return awake;
}

// Sinds wanneer het beeld weg is, of null als het aan staat.
export function screenDarkSince() {
  return darkAt;
}

// Geeft een opzegfunctie terug.
export function onScreenChange(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Meerdere keren aanroepen mag: er loopt maar één meting.
export function startScreenWatch() {
  if (typeof window === "undefined") return () => {};

  watchers += 1;
  if (watchers === 1) {
    lastCheckAt = Date.now();
    lastFrameAt = lastCheckAt;
    frames = 0;
    lowSince = 0;
    rafId = requestAnimationFrame(tick);
    timerId = setInterval(check, screenCheckMs);
  }

  return () => {
    watchers = Math.max(0, watchers - 1);
    if (watchers > 0) return;
    cancelAnimationFrame(rafId);
    clearInterval(timerId);
    // Een nieuwe start begint niet in een oude donkere stand.
    awake = true;
    darkAt = null;
  };
}
